'use client';

import { useRouter, useSearchParams } from 'next/navigation';

import { useTranslation } from '@/lib/i18n/i18n.client';

import { Input } from '../../atoms/Input';
import { Spinner } from '../../atoms/spinner';
import { useFeedControls } from './FeedControlsContext';

import iconSearchSrc from '~/svg/IconSearch.svg';
import { SvgIcon } from '@/components/SvgIcon';

type Props = {
  defaultQuery?: string;
};

export function Search({ defaultQuery }: Props) {
  const { texts } = useTranslation();
  const router = useRouter();
  const searchParams = useSearchParams();
  const { isPending, startTransition } = useFeedControls();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const queryEl = e.currentTarget.elements.namedItem(
      'query'
    ) as HTMLInputElement;
    const query = queryEl?.value;

    const params = new URLSearchParams(searchParams);

    if (query) {
      params.set('query', query);
    } else {
      params.delete('query');
    }

    const qs = params.toString();
    startTransition(() => {
      router.replace(`/blog${qs ? `?${qs}` : ''}`, { scroll: false });
    });
  };

  return (
    <form className='flex w-full' onSubmit={handleSubmit}>
      <Input
        classNames={{
          root: 'flex-grow h-10 items-center',
          rightIcon: 'py-7 pr-9 pointer-events-auto cursor-pointer z-10',
        }}
        type='text'
        name='query'
        defaultValue={defaultQuery}
        placeholder={texts.articles_feed.search_in_blog}
        leftIcon={isPending ? <Spinner color='gray-500' /> : null}
        rightIcon={<SvgIcon src={iconSearchSrc} className='text-base-black h-5' />}
      />
    </form>
  );
}
